import type { InternalTransaction } from '../types'

export const createInternalTransactionId = (
  transaction: InternalTransaction,
): string =>
  [
    transaction.contractAddress ?? '',
    transaction.from,
    transaction.gas.toString(),
    transaction.isError ? '1' : '0',
    transaction.to ?? '',
    transaction.txHash,
    transaction.value.toString(),
  ].join('/')
